// Dormant by design: rendered only when approved client/partner/press logos exist.
const SHOW_CREDIBILITY = false;

export const Credibility = () => {
  if (!SHOW_CREDIBILITY) return null;
  return (
    <section data-testid="credibility-section" className="px-6 md:px-12 lg:px-24 py-20 border-t border-charcoal/10">
      <p className="text-[11px] uppercase tracking-[0.34em] text-charcoal-mute mb-10">
        Selected Clients &amp; Press
      </p>
      <div className="flex flex-wrap items-center gap-x-14 gap-y-8">
        {/* Approved logo lockups go here — no placeholders. */}
      </div>
    </section>
  );
};
